module.exports = __webpack_public_path__ + "img/calendar-13_fill.22197a39.svg";